var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDepartment(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.66667 16.6667H3.33334M3.33334 16.6667H12.5M3.33334 16.6667V11.9733C3.33334 11.5358 3.33334 11.3167 3.38584 11.1125C3.43306 10.9303 3.50862 10.7608 3.61251 10.6042C3.72917 10.4292 3.89251 10.2817 4.21834 9.99L6.13584 8.26666C6.76501 7.70166 7.07917 7.41916 7.43584 7.31166C7.74943 7.21717 8.08391 7.21717 8.39751 7.31166C8.75417 7.41916 9.06917 7.70166 9.69917 8.26749L11.6158 9.99C11.9408 10.2817 12.1033 10.4292 12.2208 10.6042C12.3242 10.76 12.4008 10.9317 12.4475 11.1125C12.5 11.3167 12.5 11.5358 12.5 11.9733V16.6667M12.5 16.6667H16.6667M16.6667 16.6667H18.3333M16.6667 16.6667V5.9975C16.6667 5.06583 16.6667 4.59916 16.485 4.24333C16.325 3.92961 16.0697 3.67464 15.7558 3.51499C15.4 3.33333 14.9333 3.33333 14 3.33333H8.50001C7.56667 3.33333 7.10001 3.33333 6.74334 3.51499C6.42975 3.67478 6.17479 3.92974 6.01501 4.24333C5.83334 4.59999 5.83334 5.06666 5.83334 5.99999V8.33333",
    stroke: "black",
    strokeWidth: 1.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDepartment);
export default __webpack_public_path__ + "static/media/Department.4e3c25b94365daffdf53bcc0f3d63bfc.svg";
export { ForwardRef as ReactComponent };